export { default } from './Etiqueta';
